<template>
  <div class="legal-page">
    <div class="legal-page__backdrop"></div>
    <div class="container py-5">
      <div class="row justify-content-center">
        <div class="col-12 col-md-10 col-lg-8">
          <!-- Header -->
          <div class="legal-header">
            <div class="legal-header__accent"></div>
            <h1 class="legal-header__title">{{ title }}</h1>
            <p class="legal-header__subtitle">{{ subtitle }}</p>
          </div>

          <!-- Content Card -->
          <div class="legal-card">
            <slot name="sections"></slot>

            <div class="legal-card__footer">
              <router-link to="/" class="back-link">
                <BIcon icon="arrow-left" />
                <span>Zurück zur Startseite</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LegalPageLayout',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  metaInfo() {
    return {
      title: `${this.title} - DailyFit`
    }
  }
}
</script>

<style scoped>
.legal-page {
  position: relative;
  min-height: 100vh;
  background: #f8f9fa;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  overflow: hidden;
}

.legal-page__backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 340px;
  background: linear-gradient(160deg, #1a1a1a 0%, #2d2d2d 100%);
  z-index: 0;
}

.legal-page__backdrop::before {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 80% 50% at 20% 80%, rgba(40, 167, 69, 0.12) 0%, transparent 70%),
    radial-gradient(ellipse 60% 40% at 80% 20%, rgba(40, 167, 69, 0.06) 0%, transparent 70%);
}

.legal-page__backdrop::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(40, 167, 69, 0.3), transparent);
}

.legal-page .container {
  position: relative;
  z-index: 1;
}

/* Header */
.legal-header {
  text-align: center;
  padding: 2rem 0 3rem;
  position: relative;
}

.legal-header__accent {
  width: 40px;
  height: 3px;
  background: #28a745;
  border-radius: 2px;
  margin: 0 auto 1.5rem;
}

.legal-header__title {
  font-size: 2.75rem;
  font-weight: 800;
  color: #ffffff;
  margin: 0 0 0.75rem;
  letter-spacing: -1px;
  line-height: 1.1;
}

.legal-header__subtitle {
  font-size: 0.9375rem;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
  font-weight: 400;
  letter-spacing: 0.2px;
}

/* Content Card */
.legal-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 3rem;
  box-shadow:
    0 1px 2px rgba(0, 0, 0, 0.04),
    0 4px 12px rgba(0, 0, 0, 0.06),
    0 20px 48px rgba(0, 0, 0, 0.06);
  animation: cardReveal 0.6s cubic-bezier(0.16, 1, 0.3, 1) both;
}

@keyframes cardReveal {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Footer / Back Link */
.legal-card__footer {
  margin-top: 3rem;
  padding-top: 2rem;
  border-top: 1px solid #f0f0f0;
  text-align: center;
}

.back-link {
  display: inline-flex;
  align-items: center;
  gap: 0.625rem;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #1a1a1a;
  text-decoration: none;
  padding: 0.75rem 1.75rem;
  border-radius: 12px;
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  transition: all 0.25s ease;
}

.back-link .bi-icon {
  font-size: 1.125rem;
  transition: transform 0.25s ease;
}

.back-link:hover {
  color: #28a745;
  border-color: #28a745;
  background: rgba(40, 167, 69, 0.04);
}

.back-link:hover .bi-icon {
  transform: translateX(-3px);
}

/* Responsive */
@media (max-width: 767.98px) {
  .legal-page__backdrop {
    height: 280px;
  }

  .legal-header {
    padding: 1.5rem 0 2.5rem;
  }

  .legal-header__title {
    font-size: 2rem;
  }

  .legal-card {
    padding: 2rem 1.5rem;
    border-radius: 16px;
  }

  .legal-card__footer {
    margin-top: 2rem;
  }
}

@media (max-width: 575.98px) {
  .legal-header__title {
    font-size: 1.75rem;
  }

  .legal-header__subtitle {
    font-size: 0.8125rem;
  }

  .legal-card {
    padding: 1.5rem 1.25rem;
  }
}
</style>
